// Domain-internal constants only — `LIVE_AGENT_*_MESSAGE` payloads stay in shared/constants.js.
// See .claude/context/live-agent.md ("What is deliberately NOT in this module").

// Analytics discriminators (the `lvQuestion` field of the submit-click payload).
// Live contracts consumed downstream — do not edit.
export const LIVE_AGENT_ANALYTICS_CONNECTION_STRING = 'lv:connect:session start';
export const LIVE_AGENT_ANALYTICS_DISCONNECTION_STRING = 'lv:disconnect:session end';
export const LIVE_AGENT_ANALYTICS_CUSTOM_MESSAGE_PREFIX = 'lv:custom:';
export const LIVE_AGENT_ANALYTICS_FIRST_MESSAGE_SUFFIX = ':is first message';
export const LIVE_AGENT_ANALYTICS_SURVEY_RECEIVED = 'lv:survey receive';
export const LIVE_AGENT_ANALYTICS_SURVEY_STARTED = 'lv:survey start';

// Escalation idle timeout; engine prefers the `sprinklr-idle-timeout` Experience Config value.
export const IDLE_TTL_MS = 6 * 60 * 60 * 1000;

// Typing indicator. Sprinklr re-emits START_TYPING about every 30s while the agent types,
// so this must clear two missed re-emits rather than one.
export const TYPING_TTL_MS = 75 * 1000;
